import { render } from "./TableSplitter.vue?vue&type=template&id=303392ed&scoped=true&ts=true"
import script from "./TableSplitter.vue?vue&type=script&lang=ts"
export * from "./TableSplitter.vue?vue&type=script&lang=ts"

import "./TableSplitter.vue?vue&type=style&index=0&id=303392ed&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303392ed"]])

export default __exports__